<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <div class="section flex flex-row gap-2.5">
    <div class="flex flex-col">
      <span class="section_title" style="margin-bottom: 10px">¿Envío estándar GRATIS?</span>
      <span class="section_info">
        Eso es, dispones del envío estándar gratuito por superar los
        <strong>{{ standardShippingThreshold }}€</strong> de pedido en Península, o los
        <strong>{{ balearShippingThreshold }}€</strong> en Baleares.
      </span>
      <span class="section_info">
        Aunque también puedes convertir tu envío en <strong>PRIORITARIO</strong> por
        <strong>{{ priorityShippingCost }}€</strong>, pide hoy y <strong>recibe mañana</strong>.
      </span>
    </div>
  </div>
</div>
